import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "../mock";

export default function FAQ({ onOpenBooking }) {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-24 lg:py-36">
      <div className="container-max">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-4">
            <span className="section-label">Domande frequenti</span>
            <h2 className="font-display text-4xl lg:text-5xl leading-[1] text-white mt-6">
              Hai altre<br />
              <span className="italic font-light text-white/60">domande?</span>
            </h2>
            <p className="text-white/60 mt-8 text-base leading-relaxed">
              Siamo qui per risponderti. Il primo passo verso il controllo digitale parte anche da questo:
              fare chiarezza.
            </p>
            <a
              href="https://api.whatsapp.com/send?phone=393204459052"
              target="_blank"
              rel="noreferrer"
              className="btn-secondary mt-8 inline-flex"
            >
              Scrivici su WhatsApp
            </a>
          </div>

          <div className="lg:col-span-8 space-y-2">
            {FAQS.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={i}
                  className="border border-white/10 bg-card rounded-2xl overflow-hidden"
                >
                  <button
                    className="w-full flex items-center justify-between gap-4 text-left px-6 py-5 lg:px-8 lg:py-6"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                  >
                    <span className="font-display text-white text-base lg:text-lg pr-4">{f.q}</span>
                    <span className="flex-shrink-0 w-9 h-9 rounded-full border border-white/15 flex items-center justify-center text-white">
                      {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-6 lg:px-8 pb-6 lg:pb-8 -mt-1">
                      <p className="text-white/65 text-base leading-relaxed">{f.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
